<template>
  
        <div class="conf-con">
                            <div class="intro-pic">
                                <img src="../../../assets/images/09.gif" alt="">
                            </div>
                            <p class="intro-tit">中国共产党第九次全国代表大会简介</p>
                            <p class="margin1">1969年4月1～24日在北京举行。出席代表1512人，代表全国2200万名党员。毛泽东主持大会开幕式并致开幕词。会议讨论并通过了林彪代表党中央作的政治报告和《中国共产党章程》。其中党章把林彪作为“毛泽东同志的亲密战友和接班人”写入总纲。大会还选举了中央委员会。</p>
                            <p class="margin1">中国共产党九届一中全会 1969年４月28日在北京举行。毛泽东主持会议并讲话。全会选举了新的中央领导机构。</p>
                            <p class="margin1">中国共产党九届二中全会 1970年８月23日～９月６日在江西庐山举行。毛泽东主持会议。周恩来宣布全会的议程，重点讨论修改宪法、国民经济第四个五年计划和加强战略问题。林彪首先发言，大赞毛泽东是天才，随后的讨论却坚决要求设立国家主席。８月25日毛泽东召开了中共中央政治局常委扩大会议，决定全会立即休会，收回华北组第二号简报。会上宣布对陈伯达进行审查。

                            </p>
                        </div>
  </template>
  
  <script>
  export default {
  
  }
  </script>
  
  <style>
  
  </style>